import React from 'react'

const Lightning = ({ className }: { className?: string }) => {
    return (
        <svg className={className} fill="none" height="30" viewBox="0 0 26 26" width="30" xmlns="http://www.w3.org/2000/svg">
<path d="M15.0865 10.5138C14.6759 10.1119 14.6759 9.47058 14.6759 8.18683V7.851C14.6759 4.29225 14.6759 2.51341 13.676 2.20683C12.6761 1.90025 11.6036 3.35083 9.45967 6.252L6.1425 10.7402C4.75042 12.6242 4.05383 13.5656 4.43733 14.3055L4.45683 14.3423C4.86308 15.0714 6.06558 15.0714 8.4695 15.0714C9.80525 15.0714 10.4737 15.0714 10.8918 15.4647" stroke="currentColor" strokeWidth="1.8"></path>
<path d="M15.0865 10.5151L15.1082 10.5357C15.5274 10.9301 16.1948 10.9301 17.5305 10.9301C19.9355 10.9301 21.1369 10.9301 21.5421 11.6581L21.5627 11.6949C21.9462 12.4359 21.2496 13.3773 19.8575 15.2591L16.5403 19.7484C14.3953 22.6496 13.3239 24.1001 12.324 23.7936C11.323 23.487 11.323 21.7081 11.3241 18.1494V17.8136C11.3241 16.5309 11.3241 15.8885 10.9135 15.4866L10.8918 15.4649" opacity="0.5" stroke="currentColor" strokeWidth="1.8"></path>
</svg>
    )
}

export default Lightning
